import { Building2, Briefcase, TrendingUp, Users } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type CareerJob = {
  id: string;
  title: string;
  department: string;
  location: string;
  type: string;
  experience: string;
  salary: string;
  posted: string;
  urgent: boolean;
};

export type CompanyInfo = {
  name: string;
  role: string;
};

export type CareerStat = {
  icon: LucideIcon;
  label: string;
  value: string;
};

export const jobListings: CareerJob[] = [
  {
    id: 'trainer-001',
    title: 'Trainer',
    department: 'Learning & Development',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '3-5 years',
    salary: '₹6-10 LPA',
    posted: '2 days ago',
    urgent: true,
  },
  {
    id: 'social-media-001',
    title: 'Social Media Manager',
    department: 'Marketing',
    location: 'Delhi',
    type: 'Full-time',
    experience: '2-4 years',
    salary: '₹5-8 LPA',
    posted: '3 days ago',
    urgent: false,
  },
  {
    id: 'graphic-designer-001',
    title: 'Graphic Designer',
    department: 'Design',
    location: 'Bangalore',
    type: 'Full-time',
    experience: '1-3 years',
    salary: '₹4-7 LPA',
    posted: '1 week ago',
    urgent: false,
  },
  {
    id: 'art-director-001',
    title: 'Art Director',
    department: 'Design',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '5-8 years',
    salary: '₹12-18 LPA',
    posted: '5 days ago',
    urgent: true,
  },
  {
    id: 'facebook-ads-001',
    title: 'Facebook Ads Expert',
    department: 'Digital Marketing',
    location: 'Remote',
    type: 'Full-time',
    experience: '2-5 years',
    salary: '₹6-12 LPA',
    posted: '1 day ago',
    urgent: true,
  },
  {
    id: 'seo-executive-001',
    title: 'SEO Executive',
    department: 'Digital Marketing',
    location: 'Delhi',
    type: 'Full-time',
    experience: '1-3 years',
    salary: '₹3-5 LPA',
    posted: '4 days ago',
    urgent: false,
  },
  {
    id: 'content-writer-001',
    title: 'Content Writer',
    department: 'Content',
    location: 'Remote',
    type: 'Full-time',
    experience: '1-3 years',
    salary: '₹3-6 LPA',
    posted: '2 days ago',
    urgent: false,
  },
  {
    id: 'relationship-manager-001',
    title: 'Relationship Manager',
    department: 'Sales',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '3-6 years',
    salary: '₹8-14 LPA',
    posted: '1 week ago',
    urgent: true,
  },
  {
    id: 'sales-executive-001',
    title: 'Sales Executive',
    department: 'Sales',
    location: 'Pune',
    type: 'Full-time',
    experience: '1-3 years',
    salary: '₹4-7 LPA',
    posted: '3 days ago',
    urgent: false,
  },
  {
    id: 'hr-executive-001',
    title: 'HR Executive',
    department: 'Human Resources',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '2-4 years',
    salary: '₹5-8 LPA',
    posted: '6 days ago',
    urgent: false,
  },
  {
    id: 'talent-acquisition-001',
    title: 'Talent Acquisition',
    department: 'Human Resources',
    location: 'Delhi',
    type: 'Full-time',
    experience: '3-5 years',
    salary: '₹6-10 LPA',
    posted: '1 day ago',
    urgent: false,
  },
  {
    id: 'video-editor-001',
    title: 'Video Editor',
    department: 'Creative',
    location: 'Mumbai',
    type: 'Full-time',
    experience: '2-4 years',
    salary: '₹5-9 LPA',
    posted: '4 days ago',
    urgent: false,
  },
];

export const companies: CompanyInfo[] = [
  { name: 'Dharohar Land Corp', role: 'Real Estate' },
  { name: 'Realty Assistant', role: 'PropTech' },
  { name: 'Go Red', role: 'Marketing' },
  { name: 'Safe Earth Infra', role: 'Infrastructure' },
  { name: 'Vulcan Engineering', role: 'Engineering' },
  { name: 'Digibee Network', role: 'Digital Solutions' },
];

export const careerStats: CareerStat[] = [
  { icon: Building2, label: 'Companies', value: '6' },
  { icon: Briefcase, label: 'Open Positions', value: '24' },
  { icon: Users, label: 'Team Members', value: '500+' },
  { icon: TrendingUp, label: 'Growth Rate', value: '40%' },
];
